import { lazy } from './lazyWithRetry';
import { Route } from 'react-router-dom';
import ProjectDetailsRoutes from './ProjectDetailsRoutes';
import { suspense } from './utils';

const ProjectsManagment = lazy(
  () => import('admin/features/projectsManagment'),
);

export default function ProjectsRoutes() {
  return (
    <>
      <Route path="taxReturns" element={suspense(<ProjectsManagment />)} />

      {ProjectDetailsRoutes()}
    </>
  );
}
